import { HttpService } from "../http";
import { OrganizationService } from "../organization";
import { getCurrentDomain } from "@root/utils/domain";
import i18next from "i18next";

const getOrganizationName = async (language: string): Promise<string> => {
  try {
    const domain = getCurrentDomain();
    const service = new OrganizationService();
    const response = await service.getOrganizationByDomain(domain);
    const data = response?.data?.data ?? response?.data;
    if (data) {
      if (language === "ko") {
        return data.certificateOrgNameKr || data.certificateOrgName || "";
      }
      return data.certificateOrgName || data.certificateOrgNameKr || "";
    }
  } catch {
    // fall through to empty string
  }
  return "";
};

export class CertificateService extends HttpService {
  async fetchCertificate(
    payload: Record<string, any>,
    language?: string,
  ): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/certificate/journalist-certificate/${payload?.courseId}`;

    const appLanguage = language?.toLowerCase() || i18next.language || "ko";
    const organizationName = await getOrganizationName(appLanguage);

    try {
      const apiResponse = await this.get(
        baseUrl,
        {
          organizationName,
          ...(payload?.journalistId
            ? { journalistId: payload?.journalistId }
            : {}),
        },

        { responseType: "blob" },
      );
      return apiResponse;
    } catch (error) {
      throw error;
    }
  }

  async fetchUsersInCsv(payload: Record<string, any>): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/organization-membership/journalist/course/${payload?.courseId}/export-csv`;

    try {
      const apiResponse = await this.get(baseUrl, payload, {
        responseType: "blob",
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  }

  fetchCertificates = async (payload: any, language?: string): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/certificate/journalist-group-certificate/${payload?.courseId}`;

    const appLanguage = language?.toLowerCase() || i18next.language || "ko";
    const { subscriberId } = payload;
    const organizationName = await getOrganizationName(appLanguage);

    try {
      const apiResponse = await this.get(
        baseUrl,
        {
          organizationName,
          subscriberId,
        },
        {
          responseType: "blob",
        },
      );
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  async fetchAllCertificates(payload: Record<string, any>): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/certificate`;

    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      console.error("Failed to fetch journalist requests:", error);
      throw error;
    }
  }
}
